'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgAward(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M10.918 13.377V9.702a4.367 4.367 0 001.477-3.291A4.394 4.394 0 007.997 2 4.394 4.394 0 003.6 6.41a4.37 4.37 0 001.563 3.371v3.596c0 .43.258.623.57.623.225 0 .397-.113.576-.285l1.576-1.57a.219.219 0 01.159-.072c.046 0 .099.02.159.073l1.576 1.57c.179.171.35.284.576.284.311 0 .563-.192.563-.623zM8.003 8.81a2.384 2.384 0 01-2.4-2.398 2.384 2.384 0 012.4-2.399c1.343 0 2.391 1.07 2.396 2.399a2.376 2.376 0 01-2.396 2.398z", fill: "currentColor" }))));
}

module.exports = SvgAward;
//# sourceMappingURL=Award.js.map
